import api from "./api";

export const getTickets = async (page = 1, page_size = 10, status = null) => {
  try {
    const params = new URLSearchParams({ page, page_size });
    if (status) {
      params.append("status", status);
    }
    const response = await api.get(`/me/tickets?${params.toString()}`);
    return response;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

export const getTicketsStatus = async (page = 1, page_size = 10, status = null) => {
  try {
    const params = new URLSearchParams({ page, page_size });
    if (status) {
      params.append("status", status);
    }
    const response = await api.get(`/me/tickets/status?${params.toString()}`);
    return response;
  } catch (error) {
    console.error("Error fetching tickets status:", error);
    throw error;
  }
};
